/* eslint-disable */
import {Link} from 'react-router-dom';
import 'contents/assets/scss/page/teacher.scss';

function StatisticsAssignment() {
  return (
    <main className="com_container p_teacher_statistics_assignment">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className="com_pg_tit icon menu2_4 active">배정관리 통계</h2>
          <div className="com_btn_wrap">
            <Link to="/Teacher/Statistics/Assignment" className="com_btn gray s">
              배정제한 교사
            </Link>
            <button className="com_btn orange s btn_plus">교사 등록</button>
          </div>
        </section>
        <section className="com_pg_container">
          <div className="box full">
            <div className="com_board_list__top">
              <section className='board_select'>
                <select className="select">
                  <option>과목 전체</option>
                </select>
              </section>              
              <section className="com_board_search end">
                <div className="date_wrap">
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <span className="divider"> ~ </span>
                  <input type="date" className="com_datepicker" placeholder="2022. 01. 01" />
                  <button className="com_btn gray s">조회</button>
                </div>
                <span className="bar" />
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                  <button className="com_btn gray ws s icon_search"></button>
                </article>
                <article className="search">
                  <input type="search" placeholder="검색할 내용을 입력해 주세요." className="input s type_search" />
                </article>
                <button className="com_btn gray s">배정제한 교사 등록</button>
              </section>
            </div>
            <table className="com_board_list">
              <colgroup>
                <col width="6%" />
                <col width="6%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="13%" />
                <col width="auto" />
                <col width="13%" />
                <col width="8%" />
              </colgroup>
              <thead>
                <tr>
                  <th>
                    <input type="checkbox" name="chk" id="chkAll" className="com_chk" />
                    <label htmlFor="chkAll"></label>
                  </th>
                  <th>No.</th>
                  <th>배정 제안일</th>
                  <th>영역</th>
                  <th>교사명</th>
                  <th>담임</th>
                  <th>주소</th>
                  <th>상태</th>
                  <th>상세보기</th>
                </tr>
              </thead>
              <tbody>
                {[2, 3, 4, 5].map((i, idx) => {
                  return (
                    <tr key={idx}>
                      <td>
                        <input type="checkbox" name="chk" id="chk01" className="com_chk" />
                        <label htmlFor="chk01"></label>
                      </td>
                      <td>{idx + 1}</td>
                      <td>2025, 08, 25</td>
                      <td>국어</td>
                      <td>
                        <button className="btn_link">김교사102</button>
                      </td>
                      <td>
                        <button className="btn_link">김담임120</button>
                      </td>
                      <td className="bg_col">수원시</td>
                      <td className="bg_col">2024, 05, 12</td>
                      <td className="bg_col td_point">
                        <button className="txt btn_link">보기</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            <div className='com_board_list__bottom'>
              <button type='button' className='com_btn xs gray'>선택한 항목 배정제안 해지</button>
              <button type='button' className='com_btn xs gray'>선택한 항목 퇴사 대상</button>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}

export default StatisticsAssignment;
